<template>
  <div class="main-content">
    <section class="section">
      <PageHeader
        v-if="!isMobile"
        :formData="formData"
        :wfDtl="wfDtl"
        :gridData="gridData"
        @wfAction="wfAction"
        @wfNoteChanged="wfNoteChanged"
        :deleteList="deleteList"
        :isEdit="(isEdit||approvalEdit)"
        :beReject="beReject"
        :hasNote="hasNote"
        :rejectnote="note"
        :page="this"
        :refno="refno"
      >
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="wfDiagramBtnClick()">
              <i class="fas fa-project-diagram mr-2"></i>{{$helper.getWord('workflow diagram')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="draftEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="draftEditButtonClicked()"
            >
              <i class="fas fa-pen mr-2"></i>{{$helper.getWord('edit')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="CancelDraftEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="CanceldraftEditButtonClicked()"
            >
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel')}}{{$helper.getWord('edit')}}
            </button>
          </div>
          
          
          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="canApprovalEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="approvalEditButtonClicked()"
            >
              <i class="fas fa-pen mr-2"></i>{{$helper.getWord('edit')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="CancelApprovalEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="CancelApprovalEditButtonClicked()"
            >
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel')}}{{$helper.getWord('edit')}}
            </button>
          </div>


          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="isEdit||approvalEdit">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>{{$helper.getWord('save')}}
            </button>
          </div>

          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel')}}
            </button>
          </div>
        </template>
      </PageHeader>
      <PageMobileHeader
        v-if="isMobile"
        :formData="formData"
        :wfDtl="wfDtl"
        :gridData="gridData"
        @wfAction="wfAction"
        @wfNoteChanged="wfNoteChanged"
        :deleteList="deleteList"
        :beReject="beReject"
        :hasNote="hasNote"
        :rejectnote="note"
        :isEdit="(isEdit||approvalEdit)"
        :page="this"
        :refno="refno"
      >
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="wfDiagramBtnClick()">
              <i class="icon-floppy-disk mr-2"></i>{{$helper.getWord('Workflow Diagram')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="draftEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="draftEditButtonClicked()"
            >
              <i class="fas fa-pen mr-2"></i>{{$helper.getWord('edit')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="CancelDraftEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="CanceldraftEditButtonClicked()"
            >
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel edit')}}
            </button>
          </div>
             <div class="mt-3 mt-lg-0 mr-lg-3" v-if="canApprovalEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="approvalEditButtonClicked()"
            >
              <i class="fas fa-pen mr-2"></i>{{$helper.getWord('edit')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="CancelApprovalEdit">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="CancelApprovalEditButtonClicked()"
            >
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel')}}{{$helper.getWord('edit')}}
            </button>
          </div>


          <div class="mt-3 mt-lg-0 mr-lg-3" v-if="isEdit||approvalEdit">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>{{$helper.getWord('save')}}
            </button>
          </div>
        </template>
      </PageMobileHeader>
      <div class="section-body">
        <div class="card">
          <!-- {{filters[3]}} -->
          <div class="card-header">
            <h4>{{$helper.getWord('Workflow History')}}</h4>
            <div class="col-md-10" v-if="isMobile" style="padding: 0px;">
              <div id="card-action" class="card-header-action">
                <h4>
                  {{$helper.getWord('Status')}}: {{wfDtl.curStep!=null?wfDtl.curStep.description:""}}
                  <template
                    v-if="computedIcon"
                  >
                    <i
                      class="fas fa-chevron-down float-right align-middle btn btn-circle"
                      @click="toggleIcon"
                      v-if="ticon"
                    ></i>
                    <i
                      class="fas fa-chevron-up float-right align-middle btn btn-circle"
                      @click="toggleIcon"
                      v-if="!ticon"
                    ></i>
                  </template>
                </h4>
              </div>
            </div>

            <div
              id="card-action"
              class="card-header-action"
              v-if="!isMobile"
            >
              <h4>{{$helper.getWord('Status')}}: {{wfDtl.curStep!=null?wfDtl.curStep.description:""}}</h4>
            </div>
            <template v-if="computedIcon&&!isMobile">
              <div class="col-md-1" v-if="ticon">
                <i
                  class="fas fa-chevron-down float-right align-middle btn btn-circle"
                  @click="toggleIcon"
                ></i>
              </div>
              <div class="col-md-1" v-if="!ticon">
                <i
                  class="fas fa-chevron-up float-right align-middle btn btn-circle"
                  @click="toggleIcon"
                ></i>
              </div>
            </template>
          </div>
          <div :style="{ display: ticon ? 'block' : 'none' }">
            <div class="card-body" v-if="!isMobile">
              <table class="table table-bordered">
                <thead class="header-bocigrey">
                    <tr>
                        <th style="width: 10%">{{$helper.getWord('Actioned')}}</th>
                        <th style="width: 20%">{{$helper.getWord('Actioned By')}}</th>
                        <th style="width: 15%">{{$helper.getWord('Received On')}}</th>
                        <th style="width: 15%">{{$helper.getWord('Actioned Date')}}</th>
                        <th style="width: 20%">{{$helper.getWord('Sent To')}}</th>
                        <th style="width: 20%">{{$helper.getWord('Comment')}}</th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-for="(workflow, index) in wfDtl.wfHistory" :key="index">
                    <td style="width: 10%">{{workflow.action}}</td>
                    <td style="width: 20%">{{workflow.user_name}}</td>
                    <td style="width: 15%">{{previousAction(wfDtl.wfHistory,index)}}</td>
                    <td style="width: 15%">{{formatDateTime(workflow.action_on)}}</td>
                    <td style="width: 20%">{{workflow.send_to}}</td>
                    <td style="width: 20%">{{workflow.note}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-body mobile" style="padding-top:0px;" v-if="isMobile">
              <div
                class="row"
                v-for="(workflow, index) in wfDtl.wfHistory"
                :key="index"
                style="border-bottom: solid 1px #eeeeee; padding-bottom: 8px; padding-top: 8px;"
              >
                <div class="col-12">
                  <div class="row" style="padding: 4px 0">
                    <div class="col-4">{{$helper.getWord('Actioned')}}:</div>
                    <div class="col-8">{{workflow.action}}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{$helper.getWord('Actioned By')}}:</div>
                    <div class="col-8">{{workflow.user_name}}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{$helper.getWord('Received On')}}:</div>
                    <div class="col-8">{{previousAction(wfDtl.wfHistory,index)}}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{$helper.getWord('Actioned Date')}}:</div>
                    <div class="col-8">{{formatDateTime(workflow.action_on)}}</div>
                  </div>
                  <div class="row">
                    <div class="col-12">{{$helper.getWord('Comment')}}:</div>
                    <div class="col-12">{{workflow.note}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <component
          :is="componentTxt"
          :fb="fb"
          :formData="formData"
          :optionData="optionData"
           @ocrfunction="ocrfunction"
           @onUpdatePreparerID="onUpdatePreparerID"
          :isMobile="isMobile"
          :fileresponse="fileresponse"
          :isEdit="isEdit"
          :approvalEdit="approvalEdit"
          :formStructure="formStructure"
          :g_recaptcha_response="g_recaptcha_response"
          :selectPreparerID ="selectPreparerID"
          :preparer_full_name="preparer_full_name"
          :createUserID="createUserID"
          ref="checking"
        />
  
      </div>
    </section>

    <!--Submit Model-->
    <div
      id="wfDiagramModal"
      class="modal fade so-alert-dialog in"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg bootstrap-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="graph"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">{{$helper.getWord('OK')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!--Submit Model-->

    <ApproveModal
      ref="approveModal"
      :approver="approver"
      :approverList="approverList"
      v-if="isInit"
    />
  </div>
</template>


<script>
import Vue from "vue";
import api from "@/api";
import config from "@/config";
import helper from "@/vueHelper";
import ApproveModal from "@/components/approveModal";
import funcs from "@/assets/js/functions"

export default {
  title: "",
  access_code: "PUBLIC",
  icon: "far fa-copy fa-fw",
  excludeSideBar:true,
  hidden: true,
  data() {
    return {
      i:null,
      ISWORK_ID: "",
      componentTxt: "",
      ticon: false,
      approver: null,
      approverList: [],
      preparer_full_name:"",
      selectPreparerID:"",
      html: "",
      fb: {
        edit: false
      },
      isInit: false,
      formStructure: {},
      formData: {},
      optionData:{},
      deleteList: [],
      deleteFileList: [],
      // formName:""
      wfDtl: {},
      wfNote: null,
      gridData: {
        itemCount: 0,
        netAmount: 0,
        gstAmount: 0,
        grossAmount: 0
      },
      createUserID:"",
      isMobile: false,
      isEdit: false,
      approvalEdit:false,
      canApprovalEdit:false,
      CancelApprovalEdit:false,
      draftEdit: false,
      beReject: false,
      hasNote: false,
      note: null,
      CancelDraftEdit: false,
      fileresponse: [],
      refno:null,
      annual_leave:null,
      g_recaptcha_response: null,
    };
  },
  created() {
    if (this.$router.history.current.path.indexOf("/Mobile/")) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },
  components: {
    ApproveModal
  },
  computed: {
    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    }
  },
  methods: {
    formatDateTime(d) {
      return helper.formatDatetime(d);
    },
    previousAction(workflows, index) {
      if (workflows.length - 1 == index) {
        return helper.formatDatetime(workflows[index].action_on);
      } else {
        return helper.formatDatetime(workflows[index+1].action_on);
      }
    },
    toggleIcon() {
      this.ticon = !this.ticon;
    },
    async init() {
      await this.loadForm();
      await this.loadFormDetail();
      this.isInit = true;
    },
    loadForm() {
      return new Promise((resolve, reject) => {
        helper.loading();
        // console.log(this.$route)
        if(this.$route.query.ISWORK_ID){
          api.request(
            this,
            "post",
            `/userBuildForm/loadUserBuildForm`,
            {
              SessionID: helper.getSessionID(),
              LocaleCode: helper.getLocaleCode(),
              Parameters: {
                id: this.$route.params.id,
                preparer_user_userid: helper.getUserID(),
                actual_user_userid: helper.getUserID(),
                ISWORK_ID: this.$route.query.ISWORK_ID
              }
            },
            function(r) {
              if (!helper.hasAccess(r.data.access_code)) {
                this.$router.push({
                  path: "/*",
                  query: {
                    msg: `You don't have permission to access on this page (CODE:${r.data.access_code})`
                  }
                });
                reject();
              }
              this.formData = r.data.formData;
              this.selectPreparerID = r.data.selectPreparerID;
              this.preparer_full_name=r.data.preparer_full_name;
              this.optionData = r.data.optionData;
              this.approver = r.data.approver;
              this.annual_leave = r.data.annual_leave;
              this.createUserID=r.data.createuser;
              this.formStructure = r.data.tableListStructure;
              if (r.data.beReject == true) {
                this.beReject = r.data.beReject;
                this.note = r.data.note;
              }
              if (r.data.wfDtl) {
                this.wfDtl = r.data.wfDtl;
              }
              this.loadGraph();

              let mkey = Object.keys(this.formData).find(o =>
                o.substring(35,o.length).startsWith("main")
              );
              this.refno = this.formData[mkey].reference_no;
              //search file column
              //add attachment list and search for files column
              for (var tbl_name in this.formData) {
                //add attachment
                if (tbl_name.substring(35,tbl_name.length).startsWith("main")) {
                  this.formData[tbl_name].attachmentList = [];
                  this.FileColumnNullToArray(
                    this.formStructure[tbl_name],
                    this.formData[tbl_name]
                  );
                } else {
                  for (let i = 0; i < this.formData[tbl_name].length; i++) {
                    this.formData[tbl_name][i].attachmentList = [];
                    this.FileColumnNullToArray(
                      this.formStructure[tbl_name],
                      this.formData[tbl_name][i]
                    );
                  }
                }
              }

              this.isEdit = r.data.isEdit;
              this.canApprovalEdit = r.data.approvalEdit;
              this.draftEdit = r.data.draftEdit;

              this.$route.meta.title =helper.getWord(r.data.formName);
              helper.done();
              resolve(true);
            },
            function(r) {
              helper.done();
              reject(r);
            },
            null
          );
        }else{
          console.log('You press too fast');
        }
      });
    },
    loadFormDetail() {
      return new Promise((resolve, reject) => {
        let $vm = this;
        this.componentTxt = "";

        if(this.$route.query.ISWORK_ID){
          api.request(
            this,
            "post",
            `/userBuildForm/getFormDetail`,
            {
              SessionID: helper.getSessionID(),
              LocaleCode: helper.getLocaleCode(),
              Parameters: {
                id: this.$route.params.id,
                ISWORK_ID: this.$route.query.ISWORK_ID
              }
            },

            function(r) {
              
               var key = CryptoJS.enc.Utf8.parse("8080808080808080");
                var iv = CryptoJS.enc.Utf8.parse("8080808080808080");
                var useCode = CryptoJS.AES.decrypt(r.data.useCode, key, {
                  keySize: 128 / 8,
                  iv: iv,
                  mode: CryptoJS.mode.CBC,
                  padding: CryptoJS.pad.Pkcs7
                }).toString(CryptoJS.enc.Utf8);
              $vm.html = useCode;
             
      // console.log($vm.html);
              let methods = {};

              //use function variable;
              Object.entries(funcs).forEach(([key,func])=>{
                methods[key] = func;
              })
              methods["ocrfunction"] = this.ocrfunction;
              methods["onUpdatePreparerID"] = this.onUpdatePreparerID;

              this.$options.components["component-layout"] = {
                props: {
                  fb: Object,
                  formData: Object,
                  optionData:Object,
                  isMobile: Boolean,
                  fileresponse: Array,
                  isEdit: Boolean,
                  approvalEdit:Boolean,
                  formStructure:Object,
                  selectPreparerID :String,
                  preparer_full_name:String,
                  createUserID:String
                },
                template: $vm.html,
                mounted() {
                  // setTimeout(function() {
                  //   Dropzone.options.filedrop = {
                  //     init: function () {
                  //       this.on("complete", function (file) {
                  //         if (this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) {
                  //           alert('testing');
                  //         }
                  //       });
                  //     }
                  //   };
                  // },500)
                },
                methods: methods
              };
              setTimeout(() => {
                $vm.componentTxt = "component-layout";
                resolve(true);
              }, 250);
            },
            function(error){
              console.log('You press too fast');
            }
          );
        }else{
          console.log("you press too fast");
        }
      });
    },
      draftEditButtonClicked() {
      this.isEdit = true;
      this.draftEdit = false;
      this.CancelDraftEdit = true;
    },
    async calling() {
      var form = await this.loadForm();
    },
    CanceldraftEditButtonClicked() {
      this.calling();
      this.CancelDraftEdit = false; // Cannot put into the setTimout()

      setTimeout(function() {
        //Wait for load form finish and trigger fbdatebox2 watch
        this.isEdit = false;
        this.draftEdit = true;
      }, 250);

      //location.reload();
      //Datebox f
    },
    approvalEditButtonClicked() {
      this.approvalEdit=true;
      this.canApprovalEdit=false;
      this.CancelApprovalEdit = true;
    },
    CancelApprovalEditButtonClicked() {
      this.calling();
      this.CancelApprovalEdit = false;
      
   
     setTimeout(function() {
        //Wait for load form finish and trigger fbdatebox2 watch
      this.approvalEdit = false;
      this.canApprovalEdit=true;
      }, 250);
      //location.reload();
      //Datebox f
    },
    checkForm(data) {
      let components = this.$refs.checking.$children; //Access component-layout's component
      let checking = true;
      let message = "";
      for (let i = 0; i < components.length; i++) {
        let column_name = components[i].fblabel;
        let value = components[i].value;
        let required = components[i].fbrequired;
        let fbtype = components[i].fbtype;
        let minlength = components[i].fbminlength;
        let maxlength = components[i].fbmaxlength;
        let textcase = components[i].fbtextcase;
        let value_length = 0;
        let component_name = components[i].$options.name;
        let recaptcha = this.g_recaptcha_response;

        if(value){
          value_length = value.length;
        }

        if(fbtype == 'annualLeave' && value <= 0){
          checking = false;
          message = "You don't have any annual leave"
        }
        
        if (required) { //REQUIRED
          if(components[i].$refs.dropZoneForm != undefined){
            var a = components[i].$refs.dropZoneForm.childElementCount >= 2; //dropzone has dargged file
            var b = $(components[i].$el).find('tr').length >= 2; //saved table has files
            if(!a && !b){
              checking = false;
              message = `Column ${column_name} haven't fill in`;
            }
          }else{
            if (required == "true" && (value == null || value === false)) {
              checking = false;
              message = `Column "${column_name}" haven't fill in, the value is ${value}`;
            }
          }
        }

        if(value && minlength && value_length < minlength){ //MIN LENGTH
          checking = false;
          message = "You don't meet the minimum length requirement (" + column_name + "), the length is " + minlength;          
        }


        if(value && maxlength && value_length > maxlength){ //MAX LENGTH
          checking = false;
          message = "You don't meet the maximum length requirement(" + column_name + "), the maximum length is " + maxlength;
        }


        if(value && textcase == 'uppercase' && value != value.toUpperCase() || value && textcase == 'lowercase' && value != value.toLowerCase()){ //TEXT CASE
          checking = false;
          message = "You don't meet the text case (" + column_name + "), the required is" + textcase;
        }

        if(component_name == "reCAPTCHA" && !recaptcha){
          checking = false;
          message = "Please authenticate the reCAPTCHA";
        }
      }
      return {checking, message};
    },
    saveButtonClicked(actionId) {
      helper.loading();
      // console.log(this.formData);

      let $vm = this;
      let $dropzones = $(".dropzone");
      let i,
        n = $dropzones.length;
      //this.checkForm(this.formData)
      if (this.checkForm(this.formData).checking) {
        if (n > 0) {
          let dropZoneFlag = [];
          for (i = 0; i < n; i++) {
            dropZoneFlag.push(false);
            let myDropzone = Dropzone.forElement($dropzones[i]);
            let currentIndex = i;

            if (myDropzone.files.length != 0) {
              myDropzone.on("complete", function(file) {
                if (
                  this.getUploadingFiles().length === 0 &&
                  this.getQueuedFiles().length === 0
                ) {
                  dropZoneFlag[currentIndex] = true;
                }

                let j;
                let isAllComplete = true;
                for (j = 0; j < dropZoneFlag.length; j++) {
                  if (dropZoneFlag[j] == false) {
                    isAllComplete = false;
                    break;
                  }
                }
                if (isAllComplete) {
                  console.log("all complete");
                  // console.log($vm.fileresponse)
                  $vm.saveForm(actionId, $vm.fileresponse);
                  //$vm.$forceUpdate();
                }
              });
            } else {
              dropZoneFlag[currentIndex] = true;
              let j;
              let isAllComplete = true;
              if ($dropzones.length == dropZoneFlag.length) {
                for (j = 0; j < dropZoneFlag.length; j++) {
                  if (dropZoneFlag[j] == false) {
                    isAllComplete = false;
                    break;
                  }
                }
                if (isAllComplete) {
                  console.log("all complete");
                  // console.log($vm.fileresponse)

                  $vm.saveForm(actionId, $vm.fileresponse);
                }
              }
            }
          }
          for (i = 0; i < n; i++) {
            let myDropzone = Dropzone.forElement($dropzones[i]);
            if (myDropzone.files.length != 0) {
              myDropzone.processQueue();
            }
          }
        } else {
          $vm.saveForm(actionId, $vm.fileresponse);
        }
        // this.$forceUpdate();
      } else {
        helper.alert(
          this.checkForm(this.formData).message
        );
        helper.done();
      }
    },
    ocrfunction(ocrDate,ocrAmount,ocrColumn,index){
       var data = this.formData;
       console.log(ocrColumn);
    var array = eval(ocrColumn);
    if(array.length >= 1){ //target + date + amount
      let target_table = array[0].split(".")[0]; 
      let target_column = array[0].split(".")[1];
      if(array.length>=2){
      let ocrDate_table = array[1].split(".")[0]; 
      let ocrDate_column = array[1].split(".")[1];
      var checkMain = ocrDate_table.includes("main_");
      if(ocrDate!=null){
        if(checkMain){
          data[ocrDate_table][ocrDate_column] = moment(ocrDate).format('DD/MM/YYYY');
        }else{
      data[ocrDate_table][index][ocrDate_column] = moment(ocrDate).format('DD/MM/YYYY');
      }
      }
      }
      if(array.length>=3){
      let ocrAmount_table = array[2].split(".")[0];
      let ocrAmount_column = array[2].split(".")[1];
      var checkMain = ocrAmount_table.includes("main_");
      if(ocrAmount!=null){
        if(checkMain){
          data[ocrAmount_table][ocrAmount_column] = ocrAmount;
        }else{
       data[ocrAmount_table][index][ocrAmount_column] = ocrAmount;
        }
      }
      }
    }else{
      console.log('error');
    }
    },
    saveForm(actionId, fileresponse) {
      let mkey = Object.keys(this.formData).find(o => o.substring(35,o.length).startsWith("main"));
      let skey = Object.keys(this.formData).find(o => o.substring(35,o.length).startsWith("sub"));
      console.warn(mkey);
      console.warn(skey);
      var mainTable = this.formData[mkey];
      // var subTable = this.formData[skey];
      console.log(this.formData);
      console.log(this.formStructure);
      api.request(
        this,
        "post",
        `/userBuildForm/saveUserBuildForm`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            id: this.$route.params.id,
            formData: this.formData,
            formStructure: this.formStructure,
            mainTable: mainTable,
            approver: this.approver,
            // subTable:subTable,
            mainTableName: mkey,
            // subTableName:skey,
            wfAction: actionId,
            wfNote: this.wfNote,
            created_by : this.formData[mkey].created_by,
            g_recaptcha_response: this.g_recaptcha_response,
            selectPreparerID:this.selectPreparerID
            //fileresponse:fileresponse     depreciated
            // table_name_lookups: this.table_name_lookups,
            // column_name_lookups: this.column_name_lookups
          }
        },
        function(r) {
          if (r.code == 202) {
            this.approver = r.data.approver;
            this.approverList = r.data.approverList||[];
            this.$refs.approveModal.showModal().then(r => {
              if (r) {
                if (!r.approver_id) {
                  helper.alert("Please select next approver");
                }
                this.saveButtonClicked(actionId);
              }else{
                this.approver = null;
                 console.log(this.approver)
              }
            }).catch(ex=>{
              
              this.approver = null;
              console.log(this.approver)
            });
            return;
          }
          console.log(r.data);
          // this.$route.params.id = r.data.form_ID;
          this.wfNote = null;
          // this.loadForm();

          // helper.clearData(this);
          if (
            this.$route.params.id == undefined ||
            this.$route.params.id == null
          ) {
            if (this.isMobile == true) {
              this.$router.push(
                "/Mobile/FORMS/FORM/request/" +
                  r.data.mainTableID +
                  "?ISWORK_ID=" +
                  this.$route.query.ISWORK_ID
              );
            } else {
              this.$router.push(
                "/FORMS/FORM/request/" +
                  r.data.mainTableID +
                  "?ISWORK_ID=" +
                  this.$route.query.ISWORK_ID
              );
            }

            location.reload();
          } else {
            location.reload();
          }
        },
        function(r) {
          console.log(r);
          //helper.done();
          // this.$forceUpdate();
          // location.reload();
        }
      );
    },
    wfAction(action) {
      let doSave = true;
      if (action && action.required_note) {
        doSave = false;
      }
      this.saveButtonClicked(action.id);
     
    },
    wfNoteChanged(value) {
      this.wfNote = value;
    },
    wfDiagramBtnClick() {
      $("#wfDiagramModal").modal("show");
    },
    cancelBtnClick() {
      this.$router.go(-1);
    },
    loadGraph() {
      if(document.getElementById("graph")){
        document.getElementById("graph").innerHTML = "";
        var graph = new Graph(document.getElementById("graph"));
        graph.resizeContainer = true;
        graph.setEnabled(false);
       var data = this.wfDtl.wfdesigner;
        if (data != null) {
          // var wfdataraw = Graph.decompress(data);
          var key = CryptoJS.enc.Utf8.parse("8080808080808080");
          var iv = CryptoJS.enc.Utf8.parse("8080808080808080");
          var wfdataraw = CryptoJS.AES.decrypt(data, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }).toString(CryptoJS.enc.Utf8);

          var xmlDoc = mxUtils.parseXml(wfdataraw);
          var codec = new mxCodec(xmlDoc);
          // console.log(codec);
          codec.decode(xmlDoc.documentElement, graph.getModel());

          var model = graph.getModel();
          var currentSelectedVertex = null;
          var isStartOrEnd = false;
          //console.log(this.wfDtl);
          //console.log(model);
          let lookupWord;

          if (this.wfDtl.curStep != null) {
            lookupWord = this.wfDtl.curStep.description;
          } else {
            lookupWord = "End";
          }

          for (const property in model.cells) {
            if (
              model.cells[property].value !== undefined &&
              model.cells[property].value.tagName == "UserObject"
            ) {
              if (model.cells[property].value.getAttribute("Key") == "STEP") {
                if (
                  model.cells[property].value.getAttribute("Name") == lookupWord
                ) {
                  currentSelectedVertex = model.cells[property];
                  isStartOrEnd = false;
                  break;
                }
              } else if (
                model.cells[property].value.getAttribute("Key") == "START" ||
                model.cells[property].value.getAttribute("Key") == "END"
              ) {
                if (
                  model.cells[property].value.getAttribute("Name") == lookupWord
                ) {
                  currentSelectedVertex = model.cells[property];
                  isStartOrEnd = true;
                  break;
                }
              }
            }
          }
          var newcells = new Object();
          var objectnum=0;
          for (var property in model.cells) {
            if (
              model.cells[property].value !== undefined &&
              model.cells[property].value.tagName == "UserObject"
            ) {
              if(model.cells[property].value.getAttribute("Key") == "STEP"){
                newcells[objectnum]=model.cells[property];
                objectnum++;
              }
              if (
                model.cells[property].value != undefined &&
                model.cells[property].value.getAttribute("Key") == "START" &&
                this.wfDtl.wfHistory.length != 0
              ) {
                var startname =
                  "Start (" +
                  this.wfDtl.wfHistory[
                    this.wfDtl.wfHistory.length - 1
                  ].user_name.toString() +
                  ")";
                model.cells[property].value.setAttribute("Name", startname);
              }
            }
          }
          for(var num in newcells){
          if (
                (newcells[num].value.getAttribute("Name") == lookupWord &&
                newcells[num].value.getAttribute("Key") == "STEP") || lookupWord == "End"
              ) {
                if(lookupWord == "End"){
                  num=Object.keys(newcells).length;
                }
                var o = 0;
                for (var i = num - 1; i >= 0; i--) {
                  if(newcells[i] != undefined){
                  if (newcells[i].value != undefined && this.wfDtl.wfHistory[o] != undefined && newcells[i].value.getAttribute("Key") == "STEP") {
                    if(this.wfDtl.wfHistory[o].action=="Reject"){
                      var user = this.wfDtl.wfHistory[o].send_to;
                      var pass=1;
                      while(pass==1){
                        o++;
                        if(this.wfDtl.wfHistory[o].user_name == user){
                          o++;
                          pass=0;
                        }
                      }
                    }
                    newcells[i].value.setAttribute("Name", this.wfDtl.wfHistory[o].user_name.toString());

                  }
                  o++;
                }
                }
              }
          }
          for(var num in newcells){
            model.cells[newcells[num].id] = newcells[num];
          }
          if (currentSelectedVertex != null) {
            //Adds animation to edge shape and makes "pipe" visible
            var state = graph.view.getState(currentSelectedVertex);
            if (isStartOrEnd) {
              state.shape.node
                .getElementsByTagName("path")[0]
                .removeAttribute("visibility");
              state.shape.node
                .getElementsByTagName("path")[0]
                .setAttribute("stroke-width", "4");
              state.shape.node
                .getElementsByTagName("path")[0]
                .setAttribute("stroke", "gray");
              state.shape.node
                .getElementsByTagName("path")[0]
                .setAttribute("class", "flow");
            } else {
              var state = graph.view.getState(currentSelectedVertex);
              state.shape.node
                .getElementsByTagName("rect")[0]
                .removeAttribute("visibility");
              state.shape.node
                .getElementsByTagName("rect")[0]
                .setAttribute("stroke-width", "4");
              state.shape.node
                .getElementsByTagName("rect")[0]
                .setAttribute("stroke", "gray");
              state.shape.node
                .getElementsByTagName("rect")[0]
                .setAttribute("class", "flow");
            }
          }
          graph.updatePlaceholders();
        }
      }else{
        console.log('You press too fast');
      }
    },
    FileColumnNullToArray(cols, row) {
      let file_col_names = [];
      //loop formStructure
      for (let i = 0; i < cols.length; i++) {
        if (cols[i].datatype == "files")
          file_col_names.push(cols[i].column_name);
      }
      //loop row to change filecolumn null to array
      for (var attr in row) {
        if (file_col_names.includes(attr) && row[attr] == null) row[attr] = [];
      }
    },
    // deleteButtonClick(index,detail_id,main_id) {
    //   if (this.formData.claimDetailList[index].id != null) {
    //     this.deleteList.push(this.formData.claimDetailList[index]);
    //   }
    //   this.formData.claimDetailList.splice(index, 1);
    //   for(var i=0;i<this.formData.detailAttachmentList[index].length;i++)
    //     this.deleteFileList.push(this.formData.detailAttachmentList[index][i])
    //   this.formData.detailAttachmentList.splice(index, 1);
    //   this.file.splice(index, 1);
    //   this.myDropzone.splice(index, 1);
    //   this.detail_number-=1
    // },

    onUpdatePreparerID(val){
      this.selectPreparerID=val;
      console.log(this.selectPreparerID);
    }

  },
  mounted() {
    // console.log(this.$route.query.FD_ID);

    this.ISWORK_ID = this.$route.query.ISWORK_ID;

    let $vm = this;

    // console.log("mounted");
    // let css =
    //   ".container-fluid {" +
    //   "padding-right: 0px;" +
    //   "padding-left: 0px;" +
    //   "}" +
    //   ".section-body{" +
    //   "padding-top: 75px !important;";
    // ("}");

    this.init();

    // if ($vm.isMobile) {
    //   var styleSheet = document.createElement("style");
    //   styleSheet.type = "text/css";
    //   styleSheet.innerText = css;
    //   document.head.appendChild(styleSheet);
    // }

    //$('.btn-block').on('click', function() { console.log('hi') });

    // this.loadForm();

    // setTimeout(() => {
    //   Vue.component("component-layout", {
    //     props:{
    //       html:String
    //     },

    //     data: function() {
    //       return {

    //       };
    //     },
    //     template:
    //       '{{html}}'
    //   });

    //    this.$nextTick(()=>{
    //       this.componentTxt = "component-layout";
    //    })

    // }, 1000);
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>
<style>
.cardDetail {
  border-color: #efefef;
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  padding-top: 0;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  margin-bottom: 12px;
}
.card-body.mobile .row .row {
  padding: 2px 0;
}

.container-fluid {
  padding-left: 0;
  padding-right: 0;
}

#graph{
  margin: auto;
  overflow: scroll;
}

#graph:first-child{
  padding-left: -50px;
}

#wfDiagramModal ::-webkit-scrollbar {
  display: none;
  padding-top: 50%;
}

#wfDiagramModal {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

#wfDiagramModal {
  z-index: 99999;
  top:15%;
}

#wfDiagramModal .modal-body{
  padding: 5px;
}
.pswp__img{
  background: white;
}
</style>
